import VerificationCodeInput from './VerificationCodeInput'

import VerificationCodeInputWrapper from './VerificationCodeInputWrapper'

export default Object.assign(VerificationCodeInput, {
  Wrapper: VerificationCodeInputWrapper,
})
